<template>
  <section class="container-fluid">
    <div class="row bg-primary text-white">
      <div class="col bg-gradient py-0">
        <div class="container bgFlagRight">
          <div class="col col-lg-10 col-xl-8 py-5 ">
            <p class="lead font-weight-medium mb-0">Goalkeeper serves Member States, Headquarters and CSDP missions and operations by supporting CSDP training, capability development and institutional memory for EU crisis management.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gradient">
      <div class="row bannerImg"></div>
    </div>
  </section>
  <section class="container mt-lg-n3">
    <div class="row row-flex mt-n5 mb-5">
      <div class="col py-0 z-1">
        <BaseCard class="pt-4 px-4 h-100 card-registrar pb-2">
          <div class="d-flex flex-column flex-lg-row justify-content-between text-primary">
            <div class="d-flex">
              <span class="material-icons-rounded fs-48 me-2 me-md-3 mt-n1">badge</span>
              <h5 class="mt-1 mb-0">REGISTRAR</h5>
            </div>
            <div class="text-muted fs-13 ms-lg-auto text-lg-end mt-1 mt-lg-0">Seconded and Seconded/Contracted<span class="d-lg-none">&nbsp;</span><br class="d-none d-lg-block">positions in CSDP Missions</div>
          </div>
          <hr class="my-3 mt-lg-3 mb-lg-4">
          <p>Job openings with the European Union CSDP Missions advertised by the EEAS. Get in touch with your national authorities for secondment opportunities or apply as expert.</p>
          <div>
            <a href="mailto:goalkeeper.registrar@eeas.europa.eu" class="underlineLink-wrapper text-decoration-none fs-14">
              <span class="material-icons-rounded fs-14 me-2">email</span><span class="underlineLink">goalkeeper.registrar@eeas.europa.eu</span>
            </a>
          </div>
          <footer class="d-flex justify-content-between">
            <a :href="registrarUrl + '/DPA/357/details.do'" class="btn-text underlineLink">Register as<span class="d-none d-lg-inline"> contracted</span> expert</a>
            <a :href="registrarUrl" class="btn-text underlineLink me-3">Login</a>
          </footer>
        </BaseCard>
      </div>
      <div class="col py-0 z-1 mt-3 mt-md-0">
        <BaseCard class="p-4 h-100 card-schoolmaster">
          <div class="d-flex flex-column flex-lg-row justify-content-between text-primary">
            <div class="d-flex">
              <span class="material-icons-rounded fs-48 me-3 mt-n1">school</span>
              <h5 class="mt-1 mb-0">SCHOOLMASTER</h5>
            </div>
            <div class="text-muted fs-13 ms-lg-auto text-lg-end mt-1 mt-lg-0">CSDP<br class="d-none d-lg-block"> Training Programme</div>
          </div>
          <hr class="my-3 mt-lg-3 mb-lg-4">
          <p>Centralised Platform for sharing training opportunities relevant for civilian and military CSDP, forming the CSDP Training Programme.</p>
          <div class="pt-md-3">
            <a href="mailto:goalkeeper.schoolmaster@eeas.europa.eu" class="underlineLink-wrapper text-decoration-none fs-14 d-block pt-2">
              <span class="material-icons-rounded fs-14 me-2">email</span><span class="underlineLink">goalkeeper.schoolmaster@eeas.europa.eu</span>
            </a>
          </div>
          <div class="align-self-end">
            <footer class="d-flex justify-content-between">
              <router-link class="btn-text underlineLink" aria-current="page" :to="{ name: 'Search' }">View courses</router-link>
              <a :href="registrarUrl" class="btn-text underlineLink me-3">Login</a>
            </footer>
          </div>
        </BaseCard>
      </div>
    </div>
    <div class="row my-5">
      <div class="col text-center my-3 mb-lg-4 my-xl-4">
        <h2 class="mb-3"><span class="blue-light">See what you can </span>learn with SCHOOLMASTER</h2>

        <div class="d-flex mb-2 pt-lg-3 mx-auto" style="max-width: 630px;">
          <span class="p-input-icon-left me-1 me-md-2 me-lg-3" style="width: 75%">
            <i class="pi pi-search" />
            <InputText v-model.trim="searchParameters.keywords" placeholder="What training are you looking for?"
                       style="width: 100%" @keyup="onTextFieldKeyPress" />
          </span>
          <Button @click="search">Search</Button>
        </div>


        <div class="d-flex flex-column flex-md-row flex-md-wrap flex-xl-nowrap justify-content-md-center justify-content-xl-between py-4 px-3 px-md-0 text-left">
          <div v-for="item in allTypes" :key="item.key" class="d-flex align-items-start mb-2 pe-3 pe-lg-4" >
            <Checkbox v-model="searchParameters.types" :name="item.name" :value="item.name" :inputId="item.value" class="me-2 me-md-1 me-xl-2"/>
            <label :for="item.value" class="text-start ms-1">{{ item.value }}</label>
          </div>
        </div>

        <div class="d-flex flex-column flex-md-row col-12 col-md-11 col-lg-10 col-xl-8 justify-content-between mx-auto ps-3 ps-md-0">
          <div v-for="(item, index) in allTopics" :key="index" class="flex-column mt-2 col col-md-6 py-0" >
            <div class="d-flex align-items-start ">
              <Checkbox v-model="searchParameters.topics" :inputId="`topic-${index}`" name="item" :value="item.id" class="me-1"/>
              <label :for="`topic-${index}`" class="ms-1">{{ item.description }}</label>
            </div>


            <div v-if="item.name === 'EUCT'" id="euctContainer" class="ps-4 my-3">
              <div v-if="!showEUCTContent">
                <div v-for="(item, index) in civilianTrainingAreasPrimaries" :key="index" class="d-flex align-items-start mb-2">
                  <Checkbox v-model="searchParameters.civilianTrainingAreas" :inputId="`civilianTrainingArea-${index}`" name="item" :value="item.id" class="me-1"/>
                  <label :for="`civilianTrainingArea-${index}`" class="ms-1 text-start">{{ item.description }}</label>
                </div>
              </div>
              <transition name="slide">
                <div v-if="showEUCTContent">
                  <div v-for="(item, index) in civilianTrainingAreasAll" :key="index" class="d-flex align-items-start mb-2">
                    <Checkbox v-model="searchParameters.civilianTrainingAreas" :inputId="`civilianTrainingArea-${index}`" name="item" :value="item.id" class="me-1"/>
                    <label :for="`civilianTrainingArea-${index}`" class="ms-1 text-start">{{ item.description }}</label>
                  </div>
                </div>
              </transition>
              <a href="#" @click.prevent="toggleCtaSubtopics" class="d-flex fs-13 topic-link-readMore underlineLink-wrapper ms-4 ps-1">
                <span v-if="!showEUCTContent"><span class="underlineLink">Show more</span><i class="pi pi-plus ms-2 fs-12 "></i></span>
                <span v-else><span class="underlineLink">Show less</span><i class="pi pi-minus ms-2 fs-12 "></i></span>
              </a>
            </div>


            <div v-if="item.name === 'MDP'" id="mdpContainer" class="ps-4 my-3">
              <div v-if="!showMDPContent">
                <div v-for="(item, index) in militaryDisciplinesPrimaries" :key="index" class="d-flex align-items-start mb-2">
                  <Checkbox v-model="searchParameters.militaryDisciplines" :inputId="`militaryDiscipline-${index}`" name="item" :value="item.id" class="me-1"/>
                  <label :for="`militaryDiscipline-${index}`" class="ms-1 text-start">{{ item.description }}</label>
                </div>
              </div>
              <transition name="slide">
                <div v-if="showMDPContent">
                  <div v-for="(item, index) in militaryDisciplinesAll" :key="index" class="d-flex align-items-start mb-2">
                    <Checkbox v-model="searchParameters.militaryDisciplines" :inputId="`militaryDiscipline-${index}`" name="item" :value="item.id" class="me-1"/>
                    <label :for="`militaryDiscipline-${index}`" class="ms-1 text-start">{{ item.description }}</label>
                  </div>
                </div>
              </transition>
              <a href="#" @click.prevent="toggleMtdSubtopics" class="d-flex fs-13 topic-link-readMore underlineLink-wrapper ms-4 ps-1">
                <span v-if="!showMDPContent"><span class="underlineLink">Show more</span><i class="pi pi-plus ms-2 fs-12"></i></span>
                <span v-else><span class="underlineLink">Show less</span><i class="pi pi-minus ms-2 fs-12"></i></span>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <section class="container mb-5">
    <div class="row">
      <div class="col py-0 text-center">
        <h2 class="mb-0 mb-md-2">Last call <span class="blue-light">for these trainings</span></h2>
      </div>
    </div>
    <div class="row mt-3">
      <CourseCard v-for="course in coursesLastCall" :key="course.id" :course="course" class="col-12 col-xl-4 pt-0 px-2 mb-2 mb-lg-3"></CourseCard>
    </div>
  </section>


  <section class="container-fluid py-5" style="background: #ECF6FF">
    <Subscribe />
  </section>

  <div class="container-fluid bannerImg">

  </div>

</template>
<script lang="ts" src="./Home.ts" ></script>

<style lang="scss" scoped>

  .bg-gradient {
    background: linear-gradient(90deg,rgb(13,116,200) 0%,rgb(65,164,244) 100%);
  }
  .row-flex {
    display: flex;
    flex-wrap: wrap;
  }
  .underlineLink-wrapper .material-icons-rounded {
    color: #8dceca;
  }

  .bannerImg {
    height: 220px;
    padding-top: 50px;
    padding-bottom: 50px;
    text-align: center;
    background-size: cover;
    background: #2196F3 url('/public/img/banner-2b-06.png') center center;
    background-blend-mode: luminosity;
  }
  @media screen and (min-width: 992px) {
    .bgFlagRight {
      background: transparent url('/public/img/eu-flag-right2.png') right -10px no-repeat;
      background-size: 320px;
      background-origin: content-box;
    }
  }
  .card-registrar,
  .card-schoolmaster {
    .underlineLink-wrapper .underlineLink {
      color: #6c757d;
      &:hover {
        color: #1976d2;
      }
    }
    hr {
      border-style: dashed;
    }
    footer {
      margin-top: 1.75rem;
      .btn-text {
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.0892857143em;
        font-weight: 500;
        transition: all 280ms ease;
      }
    }
  }

  a.topic-link-readMore {
    color: #b5babf;
    text-decoration: none;
    &:hover {
      text-decoration: none;
      color: #1976d2;
    }
  }

</style>
